<template>
  <DialogContainer v-model="dialogObj">
    <template v-slot:dialogSlot>
      <div class="business-body custom-form">
        <template>
          <el-row :gutter="20">
            <el-form ref="form" :model="form" :rules="rules" label-position="top">
              <el-col :span="24">
                <el-form-item prop="remark">
                  <el-input
                    v-model="form.remark"
                    clearable
                    type="textarea"
                    style="width: 100%"
                    rows="5"
                    show-word-limit
                    autocomplete="off"
                    maxlength="500"
                    placeholder="请输入备注">
                  </el-input>
                </el-form-item>
              </el-col>
            </el-form>
          </el-row>
        </template>
      </div>
    </template>
  </DialogContainer>
</template>

<script>
import DialogContainer from "@/components/Dialog.vue";
import {reconcile} from "./api";
export default {
  name: "JieSuan",
  components: {
    DialogContainer,
  },
  data() {
    return {
      dialogObj: {
        loading: false,
        btnLoading: false,
        width: "30%",
        show: false,
        title: "结算",
        closeOnClickModal: false,
        confirmFn: this.submitForm,
        beforeClose: (v) => {
          this.form = this.$options.data().form;
          if (this.$refs.form) this.$refs.form.resetFields();
          this.dialogObj.show = false;
          this.dialogObj.btnLoading = false;
        },
      },
      form: {
        billId: "",
        remark: "",
      },
      detail: {},
      rules: {},
    };
  },
  mounted() {},
  methods: {
    init(row) {
      this.form.billId = row.billId;
      this.dialogObj.show = true;
    },
    // 提交数据
    submitForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.dialogObj.btnLoading = true;
          reconcile({
            billId: this.form.billId,
            remark: this.form.remark
          })
            .then((res) => {
              this.dialogObj.btnLoading = false;
              if (res.code === 200) {
                this.$message.success("结算成功");
                this.$parent.handleAddOrEditSuccess("edit");
                this.dialogObj.beforeClose();
              }
            })
            .catch((e) => {
              this.dialogObj.btnLoading = false;
            });
        } else {
          return false;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.business-body {
  box-sizing: border-box;
  .order-detail-box {
    display: flex;
    width: 100%;
    height: 0.8rem;
    background: #f7fbff;
    padding: 0.1rem;
    border-radius: 0.08rem;
    box-sizing: border-box;
    margin-bottom: 0.2rem;
    .label-val {
      width: 33.3%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      position: relative;
      .label-1 {
        color: #8c8c8c;
        font-size: 0.12rem;
        padding-bottom: 0.06rem;
      }
      .value-1 {
        color: #434343;
      }
    }
    .label-val:after {
      content: "";
      position: absolute;
      right: 0;
      width: 0.01rem;
      height: 0.26rem;
      background: #dce5f5;
    }
    .label-val:nth-last-of-type(1):after {
      display: none;
    }
  }
  .title-box {
    padding: 0rem 0 0.1rem;
    color: #000000;
    .title-label {
      width: 0.08rem;
      height: 0.08rem;
      margin-right: 0.06rem;
    }
  }
  .common-info-box {
    padding: 0.1rem;
    box-sizing: border-box;
    background: #f7f8fb;
    line-height: 0.24rem;
    border-radius: 0.08rem;
  }
  .common-image-box {
    margin-bottom: 0;
    margin-top: 0.04rem;
  }
  .invice-info {
    line-height: 0.24rem;
    margin-bottom: 0.2rem;
  }
  .radio-box {
    display: flex;
    align-items: center;
    span {
      font-size: 0.12rem;
      color: #8c8c8c;
    }
  }
}
</style>
